<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PAYMENT_TERMS.EDIT_PAYMENT_TERM") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <payment-term-form
              :loading="loading"
              :paymentTermData="paymentTerm"
              :formErrors="formErrors"
              @paymentTermSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentTermForm from "./partials/PaymentTermForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPaymentTerm from "./defaultPaymentTerm";

export default {
  layout: "DashboardLayout",

  components: { PaymentTermForm },

  mixins: [alertLeave],

  data() {
    return {
      paymentTerm: cloneDeep(defaultPaymentTerm),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("paymentTerms/get", id);
        this.paymentTerm = this.$store.getters["paymentTerms/paymentTerm"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List PaymentTerms" });
    },

    viewpaymentTerm() {
      this.alertLeave = false;
      this.$router.push({
        name: "View PaymentTerm",
        params: { id: this.paymentTerm.id },
      });
    },

    async handleSubmit(paymentTerm) {
      this.loading = true;
      const paymentTermData = cloneDeep(paymentTerm);

      try {
        await this.$store.dispatch("paymentTerms/update", paymentTermData);
        this.$notify({
          type: "success",
          message: this.$t("PAYMENT_TERMS.PAYMENT_TERM_UPDATED"),
        });
        this.viewpaymentTerm();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
